import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchModule, type FunnelEnvelope, type ModuleFilters } from '../api/events';

/**
 * Stable query key for the Events → Funnel module envelope. Exported so
 * sibling code (e.g. an invalidator after an ingest) can refer to the
 * same key without re-deriving it.
 */
export function eventsFunnelKey(filters?: ModuleFilters) {
  return ['events', 'funnel', filters ?? {}] as const;
}

/**
 * Fetch the Events → Funnel envelope (totals + optional district
 * breakdown + freshness/honesty metadata).
 *
 * Returns the full envelope so consumers can render `<Freshness/>`,
 * `<Denominator/>`, and `<AnomalyChip/>` alongside the chart.
 */
export function useEventsFunnel(
  filters?: ModuleFilters,
): UseQueryResult<FunnelEnvelope, Error> {
  return useQuery({
    queryKey: eventsFunnelKey(filters),
    queryFn: ({ signal }) => fetchModule('funnel', filters, { signal }),
    staleTime: 5 * 60 * 1000,
  });
}
